import { render } from "./Technical.vue?vue&type=template&id=1216dd55"
import script from "./Technical.vue?vue&type=script&lang=js"
export * from "./Technical.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Microsoft VS Code Project\\startkit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__